export default function Footer() {
  return (
    <footer className="border-t border-orange-100 bg-gradient-to-r from-amber-50 via-orange-50 to-amber-50">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-6 px-4 py-10 md:px-6">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-start">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-amber-400 to-orange-500 text-white">
                <i className="ri-radar-line" />
              </span>
              <span className="text-lg font-black tracking-tight text-orange-700">看料</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-stone-500">
              看料网址导航与地址汇总，分类清晰、持续收录新地址，热门站点一键直达不迷路，入口失效随时补充更新。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-10 gap-y-2 text-sm sm:grid-cols-3">
            <div className="flex flex-col gap-2">
              <span className="text-xs font-semibold text-stone-400">快速导航</span>
              <a href="#hero" className="whitespace-nowrap text-stone-600 hover:text-orange-600">精选直达</a>
              <a href="#board" className="whitespace-nowrap text-stone-600 hover:text-orange-600">分区导航</a>
              <a href="#hot" className="whitespace-nowrap text-stone-600 hover:text-orange-600">实时热榜</a>
            </div>
            <div className="flex flex-col gap-2">
              <span className="text-xs font-semibold text-stone-400">信息</span>
              <a href="#discuss" className="whitespace-nowrap text-stone-600 hover:text-orange-600">新收录速报</a>
              <a href="#wall" className="whitespace-nowrap text-stone-600 hover:text-orange-600">话题墙</a>
              <a href="#discuss" className="whitespace-nowrap text-stone-600 hover:text-orange-600">失效反馈</a>
            </div>
            <div className="flex flex-col gap-2">
              <span className="text-xs font-semibold text-stone-400">关联</span>
              <a href="#hero" className="whitespace-nowrap text-stone-600 hover:text-orange-600">看料入口</a>
              <a href="#hero" className="whitespace-nowrap text-stone-600 hover:text-orange-600">看料直达</a>
            </div>
          </div>
        </div>

        <div className="border-t border-orange-100 pt-5 text-center text-xs text-stone-400">
          © {new Date().getFullYear()} 看料 · 仅作网址导航地址汇总展示，不提供亦不存储任何内容本身。
        </div>
      </div>
    </footer>
  );
}